import { render, staticRenderFns } from "./WizDebugControl.vue?vue&type=template&id=5ec36f31&"
import script from "./WizDebugControl.vue?vue&type=script&lang=js&"
export * from "./WizDebugControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec36f31')) {
      api.createRecord('5ec36f31', component.options)
    } else {
      api.reload('5ec36f31', component.options)
    }
    module.hot.accept("./WizDebugControl.vue?vue&type=template&id=5ec36f31&", function () {
      api.rerender('5ec36f31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/WizDebugControl.vue"
export default component.exports